module.exports = __webpack_public_path__ + "img/up-icon-orange.4fd29c57.svg";